import { isNewMenuLive } from '@/lib/experienceLaunch';
import { useEffect, useState } from 'react';

export function useNewMenuLive() {
  const [isLive, setIsLive] = useState(() => isNewMenuLive());

  useEffect(() => {
    const sync = () => setIsLive(isNewMenuLive());
    sync();

    const intervalId = window.setInterval(sync, 60_000);
    return () => window.clearInterval(intervalId);
  }, []);

  return isLive;
}
